import React from 'react';

import type { ISerializers } from 'components/sanity-block-renderer/types';

import { ListItem } from './styled';

interface IListSerializerProps {
  type?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
}

interface IListItemSerializerProps {
  children?: React.ReactNode;
  [key: string]: unknown;
}

const serializers: ISerializers = {
  list: ({ type, children }: IListSerializerProps) => {
    const isBulletList = type === 'bullet';
    return React.Children.toArray(children).map((listItem, index) => {
      const listIndicator = isBulletList ? '\u2022' : `${index + 1}.`;
      return (
        <ListItem key={index}>
          {listIndicator} {listItem}
        </ListItem>
      );
    });
  },
  listItem: ({ children }: IListItemSerializerProps) => <ListItem>{children}</ListItem>,
};

export default serializers;
